import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  AddDocumentTypeResponse,
  DocumentTypeItem,
  DocumentTypeResponse,
} from '@core/interface/document-type';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentTypeService {
  constructor(private http: HttpClient) {}

  getDocumentTypes(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<DocumentTypeResponse>(
      environment.endPoints.documentTypeList,
      {
        params: httpParams,
      }
    );
  }
  addDocumentType(data: DocumentTypeItem) {
    return this.http.post<AddDocumentTypeResponse>(
      environment.endPoints.documentTypeAddEdit,
      data
    );
  }
}
